module.exports = __webpack_public_path__ + "img/research_6.84bc52e9.jpg";